module.exports = __webpack_public_path__ + "static/img/lianjie-tianchong.1aca5b04.png";